const country = {
  zh: {
    africa: [
      "埃及",
      "南苏丹",
      "坦桑尼亚",
      "喀麦隆",
      "佛得角",
      "尼日尔",
      "布基纳法索",
      "利比亚",
      "埃塞俄比亚",
      "乌干达",
      "赤道几内亚",
      "塞拉利昂",
      "尼日利亚",
      "几内亚",
      "突尼斯",
      "厄立特里亚",
      "卢旺达",
      "加蓬",
      "利比里亚",
      "毛里塔尼亚",
      "几内亚比绍",
      "阿尔及利亚",
      "索马里",
      "布隆迪",
      "刚果共和国",
      "科特迪瓦",
      "西撒哈拉",
      "佛得角",
      "摩洛哥",
      "吉布提",
      "塞舌尔",
      "几内亚比绍",
      "加纳",
      "塞内加尔",
      "塞拉利昂",
      "苏丹",
      "肯尼亚",
      "乍得",
      "马里",
      "贝宁",
      "冈比亚",
      "利比里亚",
    ],
    asia: [
      "中国",
      "越南",
      "新加坡",
      "印度",
      "塔吉克斯坦",
      "叙利亚",
      "巴林",
      "蒙古",
      "老挝",
      "印度尼西亚",
      "巴基斯坦",
      "乌兹别克斯坦",
      "约旦",
      "卡塔尔",
      "朝鲜",
      "柬埔寨",
      "东帝汶",
      "斯里兰卡",
      "土库曼斯坦",
      "黎巴嫩",
      "科威特",
      "韩国",
      "缅甸",
      "尼泊尔",
      "马尔代夫",
      "阿富汗",
      "以色列",
      "阿联酋",
      "日本",
      "泰国",
      "不丹",
      "哈萨克斯坦",
      "伊拉克",
      "巴勒斯坦",
      "阿曼",
      "菲律宾",
      "马来西亚",
      "孟加拉国",
      "吉尔吉斯斯坦",
      "伊朗",
      "沙特阿拉伯",
      "也门",
      "格鲁吉亚",
      "文莱",
      "亚美尼亚",
      "阿塞拜疆",
      "土耳其",
      "塞浦路斯",
    ],
    europe: [
      "芬兰",
      "拉脱维亚",
      "捷克",
      "英国",
      "罗马尼亚",
      "克罗地亚",
      "西班牙",
      "瑞典",
      "立陶宛",
      "斯洛伐克",
      "爱尔兰",
      "保加利亚",
      "黑山",
      "葡萄牙",
      "挪威",
      "白俄罗斯",
      "匈牙利",
      "荷兰",
      "塞尔维亚",
      "马耳他",
      "安道尔",
      "冰岛",
      "俄罗斯",
      "德国",
      "比利时",
      "马其顿",
      "波黑",
      "直布罗陀",
      "丹麦",
      "乌克兰",
      "奥地利",
      "卢森堡",
      "阿尔巴尼亚",
      "意大利",
      "法罗群岛",
      "摩尔多瓦",
      "瑞士",
      "法国",
      "希腊",
      "梵蒂冈",
      "爱沙尼亚",
      "波兰",
      "列支敦士登",
      "摩纳哥",
      "斯洛文尼亚",
      "圣马力诺",
    ],
    latin: [
      "墨西哥",
      "萨尔瓦多",
      "牙买加",
      "圣文森特和格林纳",
      "格陵兰(丹)",
      "洪都拉斯",
      "海地",
      "丁斯",
      "危地马拉",
      "尼加拉瓜",
      "多米尼加",
      "格林纳达",
      "伯利兹",
      "哥斯达黎加",
      "安提瓜和巴布达",
      "巴巴多斯",
      "古巴",
      "巴拿马",
      "圣基茨和尼维斯",
      "特立尼达和多巴哥",
      "圣卢西亚",
      "巴哈马",
      "多米尼克",
      "波多黎各(美)",
    ],
    north: ["美国", "美属维尔京样岛", "加拿大", "圣皮埃尔和密克隆"],
    oceania: [
      "澳大利亚",
      "库克群岛",
      "马绍尔群岛",
      "瑙鲁",
      "新西兰",
      "斐济",
      "基里巴斯",
    ],
  },
  en: {
    africa: [
      "Egypt",
      "South Sudan",
      "Tanzania",
      "Cameroon",
      "Cape Verde",
      "Niger",
      "Burkina Faso",
      "Libya",
      "Ethiopia",
      "Uganda",
      "Equatorial Guinea",
      "Sierra Leone",
      "Nigeria",
      "Guinea",
      "Tunisia",
      "Eritrea",
      "Rwanda",
      "Gabon",
      "Liberia",
      "Mauritania",
      "Guinea-Bissau",
      "Algeria",
      "Somalia",
      "Burundi",
      "Republic of the Congo",
      "Ivory Coast",
      "Western Sahara",
      "Cape Verde",
      "Morocco",
      "Djibouti",
      "Seychelles",
      "Guinea-Bissau",
      "Ghana",
      "Senegal",
      "Sierra Leone",
      "Sudan",
      "Kenya",
      "Chad",
      "Mali",
      "Benin",
      "Gambia",
      "Liberia",
    ],
    asia: [
      "China",
      "Vietnam",
      "Singapore",
      "India",
      "Tajikistan",
      "Syria",
      "Bahrain",
      "Mongolia",
      "Laos",
      "Indonesia",
      "Pakistan",
      "Uzbekistan",
      "Jordan",
      "Qatar",
      "North Korea",
      "Cambodia",
      "East Timor",
      "Sri Lanka",
      "Turkmenistan",
      "Lebanon",
      "Kuwait",
      "South Korea",
      "Myanmar",
      "Nepal",
      "Maldives",
      "Afghanistan",
      "Israel",
      "United Arab Emirates",
      "Japan",
      "Thailand",
      "Bhutan",
      "Kazakhstan",
      "Iraq",
      "Palestine",
      "Oman",
      "Philippines",
      "Malaysia",
      "Bangladesh",
      "Kyrgyzstan",
      "Iran",
      "Saudi Arabia",
      "Yemen",
      "Georgia",
      "Brunei",
      "Armenia",
      "Azerbaijan",
      "Turkey",
      "Cyprus",
    ],
    europe: [
      "Finland",
      "Latvia",
      "Czech Republic",
      "United Kingdom",
      "Romania",
      "Croatia",
      "Spain",
      "Sweden",
      "Lithuania",
      "Slovakia",
      "Ireland",
      "Bulgaria",
      "Montenegro",
      "Portugal",
      "Norway",
      "Belarus",
      "Hungary",
      "Netherlands",
      "Serbia",
      "Malta",
      "Andorra",
      "Iceland",
      "Russia",
      "Germany",
      "Belgium",
      "North Macedonia",
      "Bosnia and Herzegovina",
      "Gibraltar",
      "Denmark",
      "Ukraine",
      "Austria",
      "Luxembourg",
      "Albania",
      "Italy",
      "Faroe Islands",
      "Moldova",
      "Switzerland",
      "France",
      "Greece",
      "Vatican City",
      "Estonia",
      "Poland",
      "Liechtenstein",
      "Monaco",
      "Slovenia",
      "San Marino",
    ],
    latin: [
      "Mexico",
      "El Salvador",
      "Jamaica",
      "Saint Vincent and the Grenadines",
      "Greenland (Denmark)",
      "Honduras",
      "Haiti",
      "Dominica",
      "Guatemala",
      "Nicaragua",
      "Dominican Republic",
      "Grenada",
      "Belize",
      "Costa Rica",
      "Antigua and Barbuda",
      "Barbados",
      "Cuba",
      "Panama",
      "Saint Kitts and Nevis",
      "Trinidad and Tobago",
      "Saint Lucia",
      "Bahamas",
      "Dominica",
      "Puerto Rico (US)",
    ],
    north: [
      "United States",
      "U.S. Virgin Islands",
      "Canada",
      "Saint Pierre and Miquelon",
    ],
    oceania: [
      "Australia",
      "Cook Islands",
      "Marshall Islands",
      "Nauru",
      "New Zealand",
      "Fiji",
      "Kiribati",
    ],
  },
};

export default country;



// WEBPACK FOOTER //
// ./src/view/product/country.js